import { useId } from "react";
import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { REGIONS, DURATION_BUCKETS, TIER_ORDER, TIER_LABELS } from "@/lib/format";

export const FilterSidebar = ({ selectedRegions, toggleRegion, regionCounts, selectedDurations, toggleDuration, selectedTiers, toggleTier, onClear }) => {
  const instance = useId();
  return <div className="filter-sidebar rounded-xl border bg-white p-5 shadow-card">
    <div className="mb-4 flex items-center justify-between">
      <h3 className="font-display text-base font-semibold text-slate-900">Filters</h3>
      <Button variant="ghost" size="sm" onClick={onClear} data-testid="catalog-clear-filters-button" className="min-h-11 px-2 text-xs text-slate-500 lg:min-h-7">Clear All</Button>
    </div>
    <div data-testid="filter-region-section">
      <p className="mb-3 text-sm font-semibold text-slate-700">Destination / Region</p>
      <div className="space-y-2">
        {REGIONS.map((region) => <Label key={region} htmlFor={`${instance}-region-${region}`} data-testid={`filter-region-label-${region.toLowerCase()}`} className="filter-option-row font-normal text-slate-600">
          <Checkbox id={`${instance}-region-${region}`} checked={selectedRegions.includes(region)} onCheckedChange={() => toggleRegion(region)} data-testid={`filter-region-checkbox-${region.toLowerCase()}`} />
          <span className="flex-1">{region}</span><span className="text-xs text-slate-400">{regionCounts?.[region] ?? ""}</span>
        </Label>)}
      </div>
    </div>
    <Separator className="my-5" />
    <div data-testid="filter-duration-section">
      <p className="mb-3 text-sm font-semibold text-slate-700">Duration</p>
      <div className="space-y-2">
        {DURATION_BUCKETS.map((duration) => <Label key={duration.key} htmlFor={`${instance}-duration-${duration.key}`} data-testid={`filter-duration-label-${duration.key}`} className="filter-option-row font-normal text-slate-600">
          <Checkbox id={`${instance}-duration-${duration.key}`} checked={selectedDurations.includes(duration.key)} onCheckedChange={() => toggleDuration(duration.key)} data-testid={`filter-duration-checkbox-${duration.key}`} />
          <span>{duration.label}</span>
        </Label>)}
      </div>
    </div>
    <Separator className="my-5" />
    <div data-testid="filter-tier-section">
      <p className="mb-3 text-sm font-semibold text-slate-700">Hotel Comfort Level</p>
      <div className="space-y-2">
        {TIER_ORDER.filter((tier) => tier !== "silver_plus").map((tier) => <Label key={tier} htmlFor={`${instance}-tier-${tier}`} data-testid={`filter-tier-label-${tier}`} className="filter-option-row font-normal text-slate-600">
          <Checkbox id={`${instance}-tier-${tier}`} checked={selectedTiers.includes(tier)} onCheckedChange={() => toggleTier(tier)} data-testid={`filter-tier-checkbox-${tier}`} />
          <span>{TIER_LABELS[tier]}</span>
        </Label>)}
      </div>
    </div>
  </div>;
};
